<template>
	<div class="content-container">
		<loading v-if="loading"></loading>
		<p>{{ description }}</p>
		<router-link :to="{ name: toRoute.name }">-&nbsp;Learn&nbsp;more</router-link>
	</div>
</template>
<script>
	import { ref, computed, watch, onMounted, inject } from "vue";
	import { useRouter } from "vue-router";

	export default {
		props: {
			to: {
				type: String,
				default: ""
			},
			width: {
				type: Number,
				default: 0
			}
		},
		emits: ["passBack"],
		setup(props, context) {
			const $error = inject("$error");
			const $http = inject("$http");
			const router = useRouter();

			const loading = ref(true);
			const summary = ref({});

			const image = computed(() => summary.value.image);
			const imageFilename = computed(() => summary.value.image?.url);
			const imageAlt = computed(() => summary.value.image?.alt);

			const description = computed(() => summary.value.description);

			const imageUrl = ref("");

			const toRoute = ref({
				name: "boyden",
				meta: {
					uuid: "4bc500c8-b4eb-11ec-8dab-afa427d3b1fb"
				}
			});

			try {
				toRoute.value = router.resolve({ name: props.to });
			} catch (e) {
				$error('No matching route found for "' + props.to + '"');
			}

			const GetPageSummary = async () => {
				try {
					const response = await $http.get("/api/v2/page/og/" + toRoute.value.meta.uuid);
					return response.data;
				} catch (err) {
					$error("Failed to get page summary.");
				}
			};

			//TODO: onMounted is causing a Warning that needs to be addressed.
			// onMounted(async () => {
			// 	summary.value = await GetPageSummary();
			// 	if (imageFilename.value) {
			// 		imageUrl.value = process.env.VUE_APP_API + "api/v2/cms/image/" + imageFilename.value;
			// 		context.emit("passBack", {
			// 			image: {
			// 				src: imageUrl.value,
			// 				alt: imageAlt.value
			// 			}
			// 		});
			// 	}
			// 	loading.value = false;
			// });

			return {
				loading,
				imageUrl,
				imageAlt,
				description,
				toRoute
			};
		}
	};
</script>
<style lang="scss">
	//@import "@/assets/css/globalVars.scss";
</style>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.content-container {
		display: flex;
		flex-direction: column;
		gap: $margin-element-small;
	}
</style>
